// src/firebase.js

// ✅ Import required Firebase modules
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ✅ Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDYq0mtkvj0_BHyeJ0RrkLXAR3QiypNIuk",
  authDomain: "myportfolio-e33fe.firebaseapp.com",
  projectId: "myportfolio-e33fe",
  storageBucket: "myportfolio-e33fe.firebasestorage.app",
  messagingSenderId: "669616974856",
  appId: "1:669616974856:web:512c6b696c1d040dd935bd",
  measurementId: "G-HVFRQR0DV9"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Initialize Analytics (optional, only works in browser)
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// ✅ Initialize Firestore (Database)
const db = getFirestore(app);

// ✅ Initialize Firebase Auth
const auth = getAuth(app);

// ✅ Initialize Firebase Storage
const storage = getStorage(app);

// ✅ Export for use in other files
export { app, analytics, db, auth, storage };
